import jsonpatch from 'fast-json-patch';
import type { Operation as JSONPatchOperation } from 'fast-json-patch/module/core';
import type { IPatchItem } from './interface';

const FLAG_VALIDATE_PATCH = true;
const FLAG_MUTATE_DOCUMENT = false;

function apply<Result = Record<string, unknown>, Source = Record<string, unknown>>(
    patchData: IPatchItem[],
    source: Source,
): Promise<Result> {
    const result = jsonpatch.applyPatch(
        source,
        patchData as JSONPatchOperation[],
        FLAG_VALIDATE_PATCH,
        FLAG_MUTATE_DOCUMENT,
    ).newDocument;

    return Promise.resolve(result as unknown as Result);
}

export default apply;
